import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'adc-filter',
  templateUrl: './adc-filter.component.html',
  styleUrls: ['./adc-filter.component.css']
})
export class AdcFilterComponent {
  @Input('defaultFilters') defaultFilters: any;
  @Input('favouriteFilterObject') favouriteFilterObject!:any;
  @Output() addedFilter!: EventEmitter<any>;
  @Output() removedFilter!: EventEmitter<any>;
  @Output() newlyCreatedFilter!: EventEmitter<any>;
  @Output() showMoreVal!: EventEmitter<any>;

  @ViewChild("dropdownRef", { static: false }) dropdownRef:  ElementRef | undefined;
  @ViewChild("dropdownRef2", { static: false }) dropdownRef2:  ElementRef | undefined;
  @ViewChild("dropdownRef3", { static: false }) dropdownRef3:  ElementRef | undefined;
  commonLayoutService: any;
  filters: any;

  public fromFavourite:any = false;
  selectedFilters: any[] = [];
  visibleFilters = [];
  hiddenFilters = [];
  showMore: boolean = false;
  // @HostListener("document:click", ["$event"]) 
  

  // onClick(event: Event) {
  //   if ( this.dropdownRef3 && !this.dropdownRef3.nativeElement.contains(event.target)) {
  //     this.filterMenuVisible = false;
  //   }
  //   if ( this.dropdownRef2 && !this.dropdownRef2.nativeElement.contains(event.target)) {
  //     this.showCreateFilter = false;
  //   }

  //   if ( this.dropdownRef && !this.dropdownRef.nativeElement.contains(event.target)) {
  //     this.showAddFilter = false;
  //   }
  // }

  public showAddFilter: boolean = false;
  public showCreateFilter: boolean = false;
  public newFilter!: string;
  public filterArr: any[] = [];

  public filterMenuVisible = false;
  public filteredData: any;
  public filterdObj: any;
  public filterLabel:string ="";
  public selectedValues:any;
  public currentFilterObj :any;

  public maxVisibleValues = 3; 

  selectedFilterObject:any = {};
  
  constructor(private cdr: ChangeDetectorRef) {
    this.addedFilter = new EventEmitter();
    this.removedFilter = new EventEmitter();
    this.newlyCreatedFilter = new EventEmitter();
    this.showMoreVal = new EventEmitter();
  }
  ngAfterViewInit(): void {
   // this.filterArr = [];
  }
  ngOnInit(): void {
    // this.showAddFilter = true;
    console.log(this.defaultFilters, "CustomComponentsModule")
    //this.filterArr = [];
    
    // if(this.favouriteFilterObject?.filterObject?.filters){
    //   this.favouriteFilterObject.filterObject.filters.forEach((inputFilter:any) =>{
    //     const defaultFilter = this.defaultFilters.find((filter: any) => filter.field === inputFilter.field);
    //     if (defaultFilter) {
    //       this.fromFavourite = true;
    //         this.addFilter({ ...defaultFilter, ...inputFilter });
    //     }
    //   })
    // }
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("someple changes ",changes)
    if (changes['favouriteFilterObject'] && changes['favouriteFilterObject'].currentValue) {
      if (changes['favouriteFilterObject'] && 
      changes['favouriteFilterObject'].currentValue &&
      changes['favouriteFilterObject'].currentValue.filterObject &&
      changes['favouriteFilterObject'].currentValue.filterObject.filters){
        this.filterArr=[];
        this.favouriteFilterObject.filterObject.filters.forEach((inputFilter:any) =>{
          const defaultFilter = this.defaultFilters.find((filter: any) => filter.field === inputFilter.field);
          if (defaultFilter) {
              this.fromFavourite = true;
              this.addFilter({ ...defaultFilter, ...inputFilter });
          }
        })
        //this.cdr.detectChanges();
      }
    }

    if(changes['defaultFilters'] && changes['defaultFilters'].currentValue) {
      console.log(changes['defaultFilters'].currentValue)
      this.filters = changes['defaultFilters'].currentValue.options;
    }
    
  }

  public openAddFilter() {
    console.log('trigerred..')
    this.showAddFilter = !this.showAddFilter;
    console.log(this.showAddFilter, 'showAddFilter')
  }

  public openCreateFilter() {
    this.showCreateFilter = !this.showCreateFilter;
  }

  public addFilter(filter: any) {

    const isSelected = this.isFilterSelected(filter);

    if (!isSelected) {
      // Add the filter if it's not already selected
      this.selectedFilters.push(filter);
    } else {
      // Remove the filter if it's already selected
      this.selectedFilters = this.selectedFilters.filter(f => f.field !== filter.field);
    }
    
    // if (!this.isFilterSelected(filter)) {
    //   this.selectedFilters.push(filter);
    // }
    const exists = this.filterArr.some((filterObj: { field: any }) => 
      filterObj.field === filter.field 
    );
    if(this.fromFavourite){
      this.filterMenuVisible = false;
    }else{
      this.filterMenuVisible = true;
    
    }
    this.filterMenuVisible = true;
    filter.filterMenuVisible = this.filterMenuVisible;

    if(filter.type == 'list' && filter.apiPath != null && filter.apiPath != ''){
      this.fetchFilterValues(filter.apiPath,filter,(updatedFilter) => {
        filter = updatedFilter;
      //  this.filterArr.push(filter);
        if(!exists){
          this.filterArr.push(filter);
          // this.currentFilterObj = filter;
          // this.selectedFilterObject[filter.field]= filter;
        }
      });
    }else{
      if(!exists){
        this.filterArr.push(filter);
        // this.currentFilterObj = filter;
        // this.selectedFilterObject[filter.field]= filter;
      }
    }
   
  // this.addedFilter.emit(filter.field);
    this.showAddFilter = false;
   
  }

  // isFilterSelected(filter: any): boolean {
  //   return this.selectedFilters.includes(filter);
  // }

  isFilterSelected(filter: any): boolean {
    return this.selectedFilters.some((selectedFilter) => selectedFilter.field === filter.field);
  }

  updateFilterMenuVisibility(fieldKey: string, newVisibility: boolean) {
    // Find the index of the object with the given field key
    const index = this.filterArr.findIndex(filter => filter.label === fieldKey);
  
    // If the object is found, update its filterMenuVisible value
    if (index !== -1) {
      this.filterArr[index].filterMenuVisible = newVisibility;
    }
  }


  public removeFilter(index: number, filterId: number, filterobj :any) {
    const filter = this.filterArr.find(f => f.id === filterId);
    this.filterArr.splice(index, 1);
    this.removedFilter.emit(filter.field);
    delete this.selectedFilterObject[filterobj.field];
    this.selectedFilters = this.selectedFilters.filter(f => f.field !== filterobj.field);
  }

  public removeEachFilter(event: Event,filter: any, value: any) {
    event.stopPropagation();
    filter.selectedValues = filter.selectedValues.filter((selectedValue: string) => selectedValue !== value);
  }

  public btnClick(action: string) {
    if(action === 'save') {
      if(this.newFilter) {
        this.newlyCreatedFilter.emit(this.newFilter);
      }
      this.showCreateFilter = false;
    } else {
      this.showCreateFilter = false;
    }
    this.newFilter = '';
  }

  applyFilter(result: any) {
    this.filterMenuVisible=result.filterMenuVisible;
    const index = this.filterArr.findIndex(filter => filter.label === result.filter.label);
    if (index !== -1) {
     if(result?.selectedValues){
        this.filterArr[index].selectedValues =result.selectedValues;
      }
      
      this.filterArr[index].filterMenuVisible =result.filterMenuVisible;
      this.filterArr[index].filterType =result.filter.filterType;
    }
    this.addedFilter.emit(result.filteredObject);
  }
  
  toggleFilterMenu(filterlabel:any) {
    this.filterLabel = filterlabel;
    this.filterMenuVisible = this.filterMenuVisible ? false : true;

    this.updateFilterMenuVisibility(filterlabel,this.filterMenuVisible);
  }

  clearFilter() {
    this.filterArr = [];
  }

  // selectAll() {
  //   this.filteredData.forEach((filter: { selected: boolean; }) => filter.selected = true);
  // }

  // selectNone() {
  //   this.filteredData.forEach((filter: { selected: boolean; }) => filter.selected = false);
  // }

  // cancel() {
  //   // Implement cancel functionality
  //   this.filterMenuVisible=false;
  // }

  // apply() {
  //   this.filterMenuVisible=false;
  //   this.selectedValues = this.filteredData
  //   .filter((item: { selected: any; }) => item.selected)
  //   .map((item: { value: any; }) => item.value);
  //   console.log("filteredAges ::: ",this.selectedValues)
  //   // Implement apply functionality
  // }
  
  fetchFilterValues(apiMethod: string,filter :any, callback: (filter: any) => void) {
    this.commonLayoutService.fetchPageConfigurationLayout(apiMethod).subscribe((response: any) => {
      this.filteredData = this.transformArray(response.data);
      this.filterdObj = this.filteredData;
      filter.data = this.filteredData;
   //   return filter;
    callback(filter);
      
    });

    //this.filterMenuVisible=true;
  }
  transformArray(input: Array<{ [key: string]: any }>): Array<{ value: string, id: number, selected: boolean }> {
    return input.map(item => ({
      value: item['dashboardName'],
      id: item['id'],
      selected: false
    }));
  }

  cancelFilter(event: any) {
    this.filterMenuVisible=event.filterMenuVisible;
    this.updateFilterMenuVisibility(event.filter.label,this.filterMenuVisible);
    }


  getVisibleValues(values: string[]): string[] {
    return values.slice(0, this.maxVisibleValues);
  }

  handleShowMore() {
    this.showMore = !this.showMore; 
    this.showMoreVal.emit(this.showMore);
  }
}
